export default "__VITE_ASSET__9637e084__"